import { authService } from '@/services/auth.service';
import { useAuthStore } from '@/store/auth.store';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface LoginFormValues {
  login: string;
  password: string;
}

export const useAdminLogin = () => {
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);

  const [values, setValues] = useState<LoginFormValues>({
    login: '',
    password: '',
  });
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setValues((prev) => ({ ...prev, [name]: value }));
    setError(null);
  }, []);

  const handleSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      if (!values.login.trim() || !values.password.trim()) {
        setError('Please fill in all fields');
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const response = await authService.login(values);
        setAuth(response.user);
        void navigate('/admin');
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Login failed';
        setError(message);
      } finally {
        setIsLoading(false);
      }
    },
    [values, setAuth, navigate]
  );

  return {
    values,
    error,
    isLoading,
    handleChange,
    handleSubmit,
  };
};
